// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
// Org
export const OrgService = {
    // GetOrg returns the organization with the given id.
    GetOrg(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    // ListOrgs returns a list of active organizations.
    ListOrgs(fn, req) {
        return fn(`/organization/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // BusinessGroups -- business_groups
    // CreateBusinessGroup creates a new business group in the org service.
    // Service account required for GRPC requests.
    CreateBusinessGroup(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ListBusinessGroups returns a list of business groups for the given org.
    ListBusinessGroups(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
    // ListAssociatedBusinessGroups returns a list of business groups associated with the given asset.
    ListAssociatedBusinessGroups(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["assetId"], "assetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups/assets/${req["assetId"]}?${fm.renderURLSearchParams(req, ["orgId", "assetId"])}`, { method: "GET" });
    },
    // UpdateBusinessGroup updates the business group with the given id.
    // Service account required for GRPC requests.
    UpdateBusinessGroup(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // Delete BusinessGroup deletes the business group with the given id.
    // Service account required for GRPC requests.
    DeleteBusinessGroup(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups/${req["id"]}?${fm.renderURLSearchParams(req, ["orgId", "id"])}`, { method: "DELETE" });
    },
    // LinkChildBusinessGroup links a child business group to a parent business group.
    // Service account required for GRPC requests.
    LinkChildBusinessGroup(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups/link`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UnlinkBusinessGroups removes the link between a child business group and a parent business group.
    // Service account required for GRPC requests.
    UnlinkBusinessGroups(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups/unlink`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // Assets
    // CreateAsset creates a new asset in the org service.
    CreateAsset(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // GetAsset returns the asset specified by the given id.
    GetAsset(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets/${req["id"]}?${fm.renderURLSearchParams(req, ["orgId", "id"])}`, { method: "GET" });
    },
    // ListAssets returns a list of assets for the given org.
    ListAssets(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
    // DeleteAsset deletes the asset with the given id.
    DeleteAsset(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets/${req["id"]}?${fm.renderURLSearchParams(req, ["orgId", "id"])}`, { method: "DELETE" });
    },
    // AddAssetLinks will create links between an asset and the provided business groups.
    AddAssetLinks(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["assetId"], "assetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets/${req["assetId"]}/links`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // RemoveAssetLinks will remove links between an asset and the provided business groups.
    RemoveAssetLinks(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["assetId"], "assetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets/${req["assetId"]}/links?${fm.renderURLSearchParams(req, ["orgId", "assetId"])}`, { method: "DELETE" });
    },
    // ReplaceAssetLinks will replace any existing links with the provided links. Links not provided in this request will be removed.
    ReplaceAssetLinks(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["assetId"], "assetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets/${req["assetId"]}/links`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // SetDefault will set the default asset (of a give type) for the given business group.
    SetDefault(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["groupId"], "groupId");
            fm.validateUrlParam(req["assetId"], "assetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups/${req["groupId"]}/assets/${req["assetId"]}/default-link`, { method: "POST" });
    },
    // RemoveDefault will remove the default asset (of a give type) for the given business group.
    RemoveDefault(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["groupId"], "groupId");
            fm.validateUrlParam(req["assetId"], "assetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/business-groups/${req["groupId"]}/assets/${req["assetId"]}/default-link?${fm.renderURLSearchParams(req, ["orgId", "groupId", "assetId"])}`, { method: "DELETE" });
    },
    // Users & Teams
    // CreateUser creates a new user in the org service.
    // Service account required for GRPC requests.
    CreateUser(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/users`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ListUsers returns a list of users for the given org.
    ListUsers(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/users?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
    // GetUser returns the user with the given id.
    GetUser(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/users/${req["id"]}?${fm.renderURLSearchParams(req, ["orgId", "id"])}`, { method: "GET" });
    },
    // DeleteUser deletes the user with the given id.
    // Service account required for GRPC requests.
    DeleteUser(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/users/${req["id"]}?${fm.renderURLSearchParams(req, ["orgId", "id"])}`, { method: "DELETE" });
    },
    // CreateTeam creates a new team in the org service.
    // Service account required for GRPC requests.
    CreateTeam(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/teams`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ListTeams returns a list of teams for the given org.
    ListTeams(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/teams?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
    // GetTeam returns the team with the given id.
    GetTeam(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/teams/${req["id"]}?${fm.renderURLSearchParams(req, ["orgId", "id"])}`, { method: "GET" });
    },
    // UpdateTeam updates the team with the given id.
    // Service account required for GRPC requests.
    UpdateTeam(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/teams/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // AddToTeam adds users to a team.
    // Service account required for GRPC requests.
    AddToTeam(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["teamId"], "teamId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/teams/${req["teamId"]}/members`, { method: "POST" });
    },
    // RemoveFromTeam removes users from a team.
    // Service account required for GRPC requests.
    RemoveFromTeam(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["teamId"], "teamId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/teams/${req["teamId"]}/members?${fm.renderURLSearchParams(req, ["orgId", "teamId"])}`, { method: "DELETE" });
    },
    // DeleteTeam deletes the team with the given id.
    // Service account required for GRPC requests.
    DeleteTeam(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/teams/${req["id"]}?${fm.renderURLSearchParams(req, ["orgId", "id"])}`, { method: "DELETE" });
    },
    // Grants
    // CreateGrant creates a new grant in the org service.
    // Service account required for GRPC requests.
    CreateGrants(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/access-grants`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ListGrants returns a list of grants for the given org.
    ListGrants(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["granteeType"], "granteeType");
            fm.validateUrlParam(req["startId"], "startId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/access-grants/${req["granteeType"]}/${req["startId"]}?${fm.renderURLSearchParams(req, ["orgId", "granteeType", "startId"])}`, { method: "GET" });
    },
    // RevokeGrant deletes the grant with the given id.
    // Service account required for GRPC requests.
    RevokeGrant(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["grantId"], "grantId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/access-grants/${req["grantId"]}?${fm.renderURLSearchParams(req, ["orgId", "grantId"])}`, { method: "DELETE" });
    },
    // Get Permissions For User  || Resolve For Context or Scope
    ResolveUserAssets(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["userId"], "userId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/resolve-assets/${req["userId"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ResolveUserGrants returns a list of asset type grants for the given user.
    ResolveUserGrants(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["userId"], "userId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/resolve-grants/${req["userId"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // FindAssetsForContext returns a list of assets for the given feature context.
    FindAssetsForContext(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets-for-context`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // FindAssetsForGroup returns a list of assets for the given business group.
    FindAssetsForGroup(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/organization/v1/${req["orgId"]}/assets-for-group`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
